"use strict";
/**
 *
 * Form
 *
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const setWith_1 = __importDefault(require("lodash/fp/setWith"));
const omit_1 = __importDefault(require("lodash/fp/omit"));
const fast_equals_1 = require("fast-equals");
const FormTag_1 = require("./FormTag");
function selector(path, state) {
    const { fields, defaultValues, values, disabled, readOnly } = state;
    const defaultValue = get_1.default(defaultValues, path);
    const value = get_1.default(values, path);
    const field = fields[path];
    if (!field) {
        return {
            defaultValue,
            value,
            changed: false,
            validityMessage: null,
            disabled,
            readOnly,
        };
    }
    return Object.assign(Object.assign({}, field), { defaultValue,
        value,
        disabled,
        readOnly });
}
function createFormField(form, path, // [K in keyof FormDefaultValues]
config = {}) {
    const { validate, immediateValidate } = config;
    let disabled = form.state.disabled;
    let readOnly = form.state.readOnly;
    let defaultValue;
    let value;
    let initialTransform = true;
    const plumb = form.chain({
        selector: (state) => selector(path, state),
        transformer: (selectedState) => {
            const changed = !fast_equals_1.deepEqual(selectedState.defaultValue, selectedState.value);
            let validityMessage = selectedState.validityMessage;
            if (validate && (changed || (immediateValidate && initialTransform))) {
                validityMessage = validate(selectedState.value);
            }
            initialTransform = false;
            return Object.assign(Object.assign({}, selectedState), { changed,
                validityMessage });
        },
        updater: (state, _a) => {
            var { changed, validityMessage } = _a, rest = __rest(_a, ["changed", "validityMessage"]);
            return (Object.assign(Object.assign({}, state), { values: setWith_1.default(() => undefined, path, rest.value, form.state.values), fields: Object.assign(Object.assign({}, form.state.fields), { [path]: {
                        validityMessage,
                        changed,
                    } }) }));
        },
        filter: (selectedState, tag) => {
            // ignore everything not field related
            switch (tag) {
                case FormTag_1.FormTag.SUBMIT_ERROR_RESET:
                case FormTag_1.FormTag.CREATE_FIELD:
                case FormTag_1.FormTag.DISPOSE_FIELD:
                case FormTag_1.FormTag.SUBMIT:
                    return false;
            }
            const changed = disabled !== selectedState.disabled ||
                readOnly !== selectedState.readOnly ||
                !fast_equals_1.deepEqual(value, selectedState.value) ||
                !fast_equals_1.deepEqual(defaultValue, selectedState.defaultValue);
            disabled = selectedState.disabled;
            readOnly = selectedState.readOnly;
            defaultValue = selectedState.defaultValue;
            value = selectedState.value;
            return changed;
        },
    }, FormTag_1.FormTag.CREATE_FIELD);
    plumb.subscribe({
        dispose: () => {
            form.next(Object.assign(Object.assign({}, form.state), { fields: omit_1.default(path, form.state.fields) }), FormTag_1.FormTag.DISPOSE_FIELD);
        },
    });
    return [
        {
            plumb,
            get state() {
                return plumb.state;
            },
            get value() {
                return plumb.state.value;
            },
            setValue: (nextValue) => {
                if (!fast_equals_1.deepEqual(plumb.state.value, nextValue)) {
                    value = nextValue;
                    plumb.next(Object.assign(Object.assign({}, plumb.state), { value: nextValue }), FormTag_1.FormTag.FIELD_VALUE_CHANGE);
                }
            },
            resetValue: () => {
                if (!fast_equals_1.deepEqual(plumb.state.defaultValue, plumb.state.value)) {
                    defaultValue = plumb.state.defaultValue;
                    value = plumb.state.value;
                    plumb.next(Object.assign(Object.assign({}, plumb.state), { value: plumb.state.defaultValue }), FormTag_1.FormTag.FIELD_VALUE_RESET);
                }
            },
        },
        () => plumb.dispose(),
    ];
}
exports.createFormField = createFormField;
